import React, { useEffect } from "react";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import Callin from "../../About/Callin";
import Infiry from "../../About/Infiry";
import Orthopediccon from "./Orthopediccon";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Orthopedic() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Orthopediccon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best Orthopaedic Clinic in Whitefield</title>
        <meta
          name="description"
          content="We are the best orthopaedic clinic in Whitefield and we have the best doctor with us. Feel free to contact us today or call us now."
        />
        <meta
          name="keywords"
          content="Best Orthopaedic Clinic in Whitefield, Best Orthopaedic Clinic in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestorthopedicservicesinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestorthopedicservicesinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield provides comprehensive orthopedic services including diagnosis and treatment of bone, joint, and muscle conditions, fracture care, joint pain management, and rehabilitation for improved mobility and quality of life.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Orthopedic diagnosis and assessment",
              "Joint pain and arthritis management",
              "Fracture care and immobilization",
              "Sports injury treatment",
              "Muscle and tendon injury care",
              "Rehabilitation and physiotherapy support",
              "Post-operative orthopedic follow-up",
            ],
            keywords: [
              "best orthopedic services in Immadihalli",
              "best orthopedic services in Whitefield",
              "best orthopedic services in Bangalore",
              "best orthopedic services in Kundalahalli",
              "best orthopedic services in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>

      <h2 style={{ display: "none" }}>
        Best Orthopaedic Clinic in Whitefield leader in musculoskeletal health
        services. Contact us for the best orthopaedic clinic in Whitefield.
      </h2>

      <Servicebanner name="Orthopedic" banner={"../photo/dd16.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
            <Divider />
          </div>
          <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Orthopedic;
